export default {
  // Inventory
  "no_films_found": "Nenhum filme encontrado correspondente a",
  "no_films_yet": "Você ainda não tem nenhum rolo de filme",
  "add_first_film": "Adicione Seu Primeiro Filme",
  "no_lenses_found": "Nenhuma lente encontrada correspondente a",
  "no_lenses_yet": "Você ainda não tem lentes",
  "add_first_lens": "Adicione Sua Primeira Lente",
  "no_cameras_found": "Nenhuma câmera encontrada correspondente a",
  "no_cameras_yet": "Você ainda não tem câmeras",
  "add_first_camera": "Adicione Sua Primeira Câmera",
  "no_items_inventory": "Nenhum item no seu inventário.",
  "inventory_management": "Gerenciamento de Inventário",
  "film": "Filme",
  "cameras": "Câmeras",
  "lenses": "Lentes",
  "search_films": "Buscar filmes...",
  "search_lenses": "Buscar lentes...",
  "search_cameras": "Buscar câmeras...",
  "add_lens": "Adicionar Lente",
  "add_film": "Adicionar Filme",
  "add_camera": "Adicionar Câmera",
  "add_new_lens": "Adicionar Nova Lente",
  "add_new_film": "Adicionar Novo Filme",
  "add_new_camera": "Adicionar Nova Câmera",
  "add_lens_details": "Preencha os detalhes abaixo para adicionar uma nova lente ao seu inventário.",
  "add_film_details": "Preencha os detalhes abaixo para adicionar um novo filme ao seu inventário.",
  "add_camera_details": "Preencha os detalhes abaixo para adicionar uma nova câmera ao seu inventário.",
  "essential_info": "Informações Essenciais",
  "optional_details": "Detalhes Opcionais",
  "brand": "Marca",
  "lens_name": "Nome/Modelo da Lente",
  "lens_name_placeholder": "50mm f/1.8, 24-70mm f/2.8, etc.",
  "brand_placeholder": "Nikon, Canon, etc.",
  "film_name": "Nome do Filme",
  "film_name_placeholder": "Portra 400, HP5 Plus, etc.",
  "camera_name": "Nome/Modelo da Câmera",
  "camera_name_placeholder": "AE-1, F3, Leica M6, etc.",
  "mount": "Montagem",
  "mount_placeholder": "ex. EF, M42",
  "mount_description": "Máximo de 4 caracteres alfanuméricos (ex., EF, M42)",
  "status": "Status",
  "select_status": "Selecionar status",
  "working": "Funcionando",
  "needs_repair": "Precisa de Reparo",
  "for_parts": "Para Peças",
  "serial_number": "Número de Série (Opcional)",
  "purchase_date": "Data de Compra (Opcional)",
  "purchase_price": "Preço de Compra (Opcional)",
  "notes": "Notas (Opcional)",
  "notes_placeholder": "Quaisquer notas adicionais sobre este item",
  "next_step": "Próximo Passo",
  "update_lens": "Atualizar Lente",
  "update_film": "Atualizar Filme",
  "update_camera": "Atualizar Câmera",
  "edit_film": "Editar Filme",
  "edit_lens": "Editar Lente",
  "edit_camera": "Editar Câmera",
  "update_film_details": "Atualize os detalhes do seu filme abaixo",
  "update_lens_details": "Atualize os detalhes da sua lente abaixo",
  "update_camera_details": "Atualize os detalhes da sua câmera abaixo",
  "delete_film": "Excluir Filme",
  "delete_lens": "Excluir Lente",
  "delete_camera": "Excluir Câmera",
  "confirm_delete_film": "Tem certeza de que deseja excluir",
  "confirm_delete_lens": "Tem certeza de que deseja excluir",
  "confirm_delete_camera": "Tem certeza de que deseja excluir",
  "from_your_inventory": "do seu inventário",
  "action_cannot_undone": "Esta ação não pode ser desfeita.",
  "film_removed_inventory": "Filme removido do inventário",
  "lens_removed_inventory": "Lente removida do inventário",
  "camera_removed_inventory": "Câmera removida do inventário",
  "failed_delete_film": "Falha ao excluir filme",
  "failed_delete_lens": "Falha ao excluir lente",
  "failed_delete_camera": "Falha ao excluir câmera",
  "cannot_delete_film_missing_id": "Não é possível excluir o filme, ID ausente",
  "cannot_delete_lens_missing_id": "Não é possível excluir a lente, ID ausente",
  "cannot_delete_camera_missing_id": "Não é possível excluir a câmera, ID ausente",
  "film_updated_successfully": "Filme atualizado com sucesso",
  "lens_updated_successfully": "Lente atualizada com sucesso",
  "camera_updated_successfully": "Câmera atualizada com sucesso",
  "error_updating_film": "Erro ao atualizar filme",
  "error_updating_lens": "Erro ao atualizar lente",
  "error_updating_camera": "Erro ao atualizar câmera",
  "cannot_update_film_missing_id": "Não é possível atualizar o filme, ID ausente",
  "cannot_update_lens_missing_id": "Não é possível atualizar a lente, ID ausente",
  "cannot_update_camera_missing_id": "Não é possível atualizar a câmera, ID ausente",
  "all": "Todos",
  "all_film": "Todos os Filmes",
  "all_lenses": "Todas as Lentes",
  "all_cameras": "Todas as Câmeras",
  "unexposed": "Não Exposto",
  "fresh": "Novo",
  "exposed": "Exposto",
  "expired": "Expirado",
  "developed": "Revelado",
  "transferring": "Transferindo:",
  "quantity_expose": "Quantidade para expor",
  "notes_optional": "Notas (opcional)",
  "mark_exposed": "Marcar como Exposto",
  "mark_film_exposed": "Marcar Filme como Exposto",
  "transfer_film_description": "Transferir filme do seu inventário para sua coleção de expostos.",
  "signin_required_inventory": "Você deve estar conectado para ver seu inventário",
  "film_details": "Detalhes do Filme",
  "lens_details": "Detalhes da Lente",
  "camera_details": "Detalhes da Câmera",
  "last_updated": "Última atualização",
  "type": "Tipo",
  "quantity": "Quantidade",
  "expiration_date": "Data de Expiração",
  "expiration": "Expiração",
  "focal_length": "Distância Focal",
  "aperture": "Abertura",
  "iso": "ISO",
  "film_type": "Tipo de Filme",
  "color": "Colorido",
  "black_and_white": "Preto e Branco",
  "slide": "Diapositivo",
  "camera_type": "Tipo de Câmera",
  "slr": "SLR",
  "dslr": "DSLR",
  "mirrorless": "Sem Espelho",
  "rangefinder": "Telêmetro",
  "point_and_shoot": "Automática",
  "instant_film": "Filme Instantâneo",
  "compatible_cameras": "Câmeras Compatíveis",
  "compatible_lenses": "Lentes Compatíveis", 
  "compatible_films": "Filmes Compatíveis",
  "are_you_absolutely_sure": "Você tem absoluta certeza?",
  "model": "Modelo",
  "error_loading_cameras": "Erro ao carregar câmeras",
  "camera_added_successfully": "Câmera adicionada com sucesso",
  "error_adding_camera": "Erro ao adicionar câmera",
  "adapter_enabled": "Adaptador habilitado",
  "adapter_mounts": "Montagens do adaptador",
  "select_format": "Selecionar formato",
  "select_camera_type": "Selecionar tipo de câmera",
  "format": "Formato",
  "medium_format": "Médio Formato",
  "large_format": "Grande Formato",
};
